import axios from "axios";
const instanceAxiosAWS = axios.create();


let BASE_URL = "https://participant.connect.us-east-1.amazonaws.com";
let headers = {
    'Content-Type' : 'application/json',
    'x-amz-bearer' : ''
}

instanceAxiosAWS.defaults.baseURL = BASE_URL;
instanceAxiosAWS.defaults.headers = headers;

export default instanceAxiosAWS;